// extracted by mini-css-extract-plugin
export var cardIcon = "_8j-5";
export var checkboxCard = "_8j-0";
export var checkboxCardSelected = "_8j-4";
export var disabled = "_8j-2";
export var interactive = "_8j-1";
export var outerBorder = "_8j-3";
export var spacerMedium = "_8j-8";
export var spacerSmall = "_8j-7";
export var spacerXsmall = "_8j-6";